import {
  IcoCash,
  IcoDiscount,
  IcoShipping
} from "@bukalapak/bazaar-visual"

export default {
  cashback: IcoCash,
  discount: IcoDiscount,
  'free-shipping': IcoShipping,
}
